/**
 * Enum for type of terms
 */
export enum TermsTypeEnum {
  TERMS = 'Terms',
  PRIVACY = 'Privacy',
}
